import React, {PureComponent} from 'react';
import { connect } from 'dva';
import { mapStateToProps } from "../../../lib/Common";
import { Button } from 'antd';

class SortPrice extends PureComponent {
  constructor(props) {
    super(props);
    this.handleSort = this.handleSort.bind(this);
  }

  /*
  componentWillMount() {
    const {model} = this.props;
    if(model === undefined){
      throw Error('<SortPrice/> Model is not set to ');
    }
  }
*/

  handleSort(e){
    const {dispatch, core:{model}} = this.props;

    dispatch({
      type: `${model}/sortPrice`
    });
  }

  render() {
    return(
      <div>
        <Button style={{ width: '100%' }} onClick={this.handleSort}>値段で並び替え</Button>
      </div>
    )
  }
}

export default connect(mapStateToProps)(SortPrice);



// WEBPACK FOOTER //
// ./src/pages/travel/components/SortPrice.js